import { App, URLOpenListenerEvent } from '@capacitor/app';
import { logSentry } from 'app/core/errors/error-utils';
import { useEffectOnce } from 'app/tools/hooks/misc-hooks';
// import { useHistory } from 'react-router-dom';

const AppUrlListener: () => null = () => {
  // const history = useHistory();
  useEffectOnce(() => {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      const url = new URL(event.url);
      const eventName = url.searchParams.get('event');
      const refCode = url.searchParams.get('code');
      // const pathname = new URL(link ?? '')?.pathname;
      if (refCode) {
        localStorage.setItem('code', refCode);
      } else if (eventName) {
        localStorage.setItem('event', eventName);
      }
      // const slug = event.url.split('.co').pop();
      // if (slug) {
      //   history.push(slug);
      // }
    }).catch(logSentry);
  });

  return null;
};

export default AppUrlListener;
